import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  Card,
  Col,
  Collapse,
  Divider,
  Dropdown,
  Form,
  Row,
  Spin,
  Tag,
  Typography,
} from "antd";

import { SettingOutlined } from "@ant-design/icons";

import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import "../../../../assets/styles/InterbankPlacement.css";
import {
  AccountFacility,
  AmountFormat,
  handleWalletAccountActionButtons,
} from "../../../../components/facilities/WalletAccountFacility";
import MainLayout from "../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../components/layouts/enhancement/TopContent";
import cnt from "../../../../services/definedConstant";
import { BOM } from "../../../../services/definedMethod";
// import {
//   apiConfig,
//   labelConfig,
//   staticConfig,
// } from "../../contractbooking.config";
import { apiConfig, labelConfig, staticConfig } from "./wallet.config";

import Transactions from "./tabs/Transactions";

const { Panel } = Collapse;
const { Text, Title } = Typography;

const ViewWalletAccount = (props) => {
  const { userData } = props;
  const { session } = userData;
  const { state } = useLocation();
  // console.log(state);
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [showInterestChecked, setShowInterestChecked] = useState(false);
  const [menuProps, setMenuProps] = useState({ items: [] });
  const [WalletAccountDetails, setWalletAccountDetails] = useState([]);
  const [activeTabKey, setActiveTabKey] = useState("transactions");
  const [transactionsList, setTransactionsList] = useState([]);
  const [templateProdDetail, setTemplateProdDetail] = useState({});
  const [useForm] = Form.useForm();
  const [counterPartyInfo, setCounterPartyInfo] = useState({});

  const maturityDate =
    BOM.DateTime(WalletAccountDetails.maturityDate, "only-date") ?? "--";

  // Optional: define known fields you want to tag as tags (for colored labels or badges in UI)
  const knownTagFields = [
    "kycStatus",
    "status",
    "sendDealConfirmation",
    "productCategory",
    "productType",
    "currency",
  ];

  const walletAccountData = {};

  const tabList = [
    {
      key: "transactions",
      label: (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span>Transactions</span>
        </div>
      ),
    },
  ];

  useEffect(() => {
    getWalletAccountById(state);
    // getTransactionDetailById(state);
  }, []);

  const getWalletAccountById = (params) => {
    const url = `${apiConfig.WalletAccount}/${params.id}`;

    let body = {
      session,
    };
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetail = res;
        console.log(objDetail);
        setWalletAccountDetails(objDetail);

        setMenuProps({
          items: handleWalletAccountActionButtons(objDetail),
          onClick: (e) => {
            console.log(e);

            const item = handleWalletAccountActionButtons(objDetail).find(
              (element) => element.key === e.key
            );
            if (item) {
              switch (item?.label.toLowerCase()) {
                case "activate":
                  return activateContract();
                case "disable":
                  return disableContract();
                case "close deal":
                  return closeContract();
                // case "reject deal":
                // return rejectContract();

                default:
                  //ROUTE REDIRECTING ACTIONS
                  return navigate(item.route, {
                    state: {
                      ...state,
                      actionLabel: item.label,
                      contractObj: objDetail,
                    },
                  });
              }
            }
          },
        });
        setIsLoading(false);
      }
    });
  };

  const getTransactionDetailById = (params) => {
    const url = `${apiConfig.InterbankContract}/${params.id}/transactions`;

    let body = {
      session,
    };
    setIsLoading(true);

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        // setAccountDetails(objDetail);
        console.log(objDetail);

        let tempChargesArray = [];
        let tempTransactionsArray = [];

        objDetail?.forEach((element) => {
          tempTransactionsArray.push({
            key: element?.id,
            id: element?.id,
            transactionDate: element?.dateOf
              ? BOM.DateTime(element?.dateOf, "only-date")
              : "-",
            transactionType: element?.transactionType
              ? element?.transactionType?.value?.replace("actionType.", "")
              : "-",
            transactionRef: element?.refNo ? element?.refNo : "-",
            amount:
              element?.amount && element?.amount !== 0
                ? Number(element?.amount).toLocaleString()
                : "-",
            balance: element?.runningBalance
              ? `${element?.currency?.code} ${element?.runningBalance}`
              : "-",
            transactionTypeDetail: element.transactionType,
          });
        });

        // setChargesList(tempChargesArray);
        setTransactionsList(tempTransactionsArray);

        setIsLoading(false);
      }
    });
  };

  const transformedData = [
    {
      section: "Product Information",
      items: [
        {
          name: "Product Name",
          value: WalletAccountDetails?.walletProductName ?? "-",
          isTag: true,
        },
        {
          name: "Product Currency",
          value:
            WalletAccountDetails?.savingsAccountData?.currency?.displayLabel ??
            "-",
          isTag: true,
        },
        {
          name: "Activation Status",
          value: WalletAccountDetails?.activateWallet
            ? "Active"
            : "Inactive" ?? "-",
          isTag: true,
        },
        {
          name: "Created Date",
          // value: formatFullDate(WalletAccountDetails?.submittedOnDate),
        },
      ],
    },

    {
      section: "Customer Eligibility",
      items: [
        {
          name: "KYC Level",
          value: WalletAccountDetails?.kycLevel
            ? WalletAccountDetails?.kycLevel?.value
            : "-",
          isTag: true,
        },
        {
          name: "Transaction Restriction",
          value: WalletAccountDetails?.transactionRestrictionType
            ? WalletAccountDetails?.transactionRestrictionType?.value
            : "-",
          isTagArray: true,
        },

        {
          name: "Customer Segment",
          value: WalletAccountDetails?.customerSegmentType
            ? WalletAccountDetails?.customerSegmentType?.value
            : "-",
          isTagArray: true,
        },
      ],
    },
    {
      section: "Account Parameters",
      items: [
        {
          name: "Account Name",
          value: WalletAccountDetails?.name ? WalletAccountDetails?.name : "-",
        },

        {
          name: "Statement Cycle",
          value: WalletAccountDetails?.statementCycleType
            ? WalletAccountDetails?.statementCycleType?.value
            : "-",
          isTagArray: true,
        },
      ],
    },
  ];

  const renderTag = (value) => {
    if (value === true) {
      return (
        <Tag
          style={{
            backgroundColor: "#ECFDF3",
            border: "1px solid #ABEFC6",
            borderRadius: "16px",
            padding: "2px 12px",
          }}
        >
          <Text
            style={{
              color: "#067647",
              fontWeight: 600,
            }}
          >
            Yes
          </Text>
        </Tag>
      );
    }

    if (value === false) {
      return (
        <Tag
          style={{
            backgroundColor: "#F9FAFB",
            border: "1px solid #EAECF0",
            borderRadius: "16px",
            padding: "2px 12px",
            textTransform: "capitalize",
          }}
        >
          <Text
            style={{
              color: "#344054",
              fontWeight: 600,
            }}
          >
            No
          </Text>
        </Tag>
      );
    }

    if (
      value === "-" ||
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return (
        <Text style={{ fontWeight: 500, color: "#6b7280" }}>
          {value || "-"}
        </Text>
      );
    }

    // Default tag for select fields
    return (
      <Tag
        style={{
          backgroundColor: "#FDF4FF",
          border: "1px solid #F6D0FE",
          borderRadius: "16px",
          padding: "2px 12px",
        }}
      >
        <Text
          style={{
            textTransform: "capitalize",
            color: "#9F1AB1",
            fontWeight: 600,
          }}
        >
          {value}
        </Text>
      </Tag>
    );
  };

  const renderRow = (item, index, section) => {
    const isLastItem =
      index === (walletAccountData[section]?.items?.length || 0) - 1;

    if (item.isInlineGroup && Array.isArray(item.group)) {
      return (
        <div
          key={`inline-group-${section}-${index}`}
          style={{
            display: "flex",
            borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
          }}
        >
          {item.group.map((fieldGroup, groupIndex) => (
            <>
              <div
                key={`group-${groupIndex}`}
                style={{
                  padding: "16px 24px",
                  width: "50%",
                  backgroundColor: "#f9f9f9",
                  fontWeight: "500",
                  borderRight: "1px solid #f0f0f0",
                }}
              >
                {fieldGroup.name}
              </div>
              <div
                style={{
                  display: "flex",
                  gap: 1,
                  padding: "16px 24px",
                  width: "50%",
                  backgroundColor: "#fff",
                }}
              >
                {fieldGroup.fields.map((subField) => (
                  <div
                    key={subField.name}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontWeight: 500,
                    }}
                  >
                    {subField.isTag ? (
                      renderTag(subField.value)
                    ) : (
                      <span>{subField.value}</span>
                    )}
                  </div>
                ))}
              </div>
            </>
          ))}
        </div>
      );
    }

    return (
      <div
        key={item.key || item.name}
        style={{
          display: "flex",
          borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
        }}
      >
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#f9f9f9",
            fontWeight: "500",
            borderRight: "1px solid #f0f0f0",
          }}
        >
          {item.name}
        </div>
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#fff",
          }}
        >
          {item.isTag ? (
            renderTag(item.value)
          ) : (
            <Text style={{ textTransform: "capitalize", fontWeight: 600 }}>
              {item.value}
            </Text>
          )}
        </div>
      </div>
    );
  };

  function activateContract() {
    setIsLoading(true);
    const params = {
      command: "activate",
    };

    const url = `${apiConfig.InterbankContract}/${state}/modify-status?`;

    const body = {
      method: "POST",
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Product Activated succesfully");
        //STOP LOAD

        getWalletAccountById(state);

        setIsLoading(false);
      }
    });
  }
  function disableContract() {
    setIsLoading(true);
    const params = {
      command: "disable",
    };
    const url = `${apiConfig.InterbankContract}/${state}/modify-status?`;

    const body = {
      method: "POST",
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Product Disabled succesfully");
        //STOP LOAD
        getWalletAccountById(state);

        setIsLoading(false);
      }
    });
  }
  function closeContract() {
    console.log("Closing..");

    setIsLoading(true);
    // const params = {
    //   command: "close",
    // };
    const url = `${apiConfig.InterbankContract}/${state.id}/close`;

    const body = {
      method: "POST",
      session,
      // params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Contract Closed succesfully");
        //STOP LOAD
        getWalletAccountById(state);

        setIsLoading(false);
      }
    });
  }

  const onTabChange = (key) => {
    setActiveTabKey(key);
  };

  const contentListNoTitle = {
    transactions: (
      <Transactions
        transactionsList={transactionsList}
        state={state}
        userData={userData}
        showInterestChecked={showInterestChecked}
        setShowInterestChecked={setShowInterestChecked}
      />
    ),
    // charges: <div>Charges</div>,
  };

  return (
    <MainLayout pageItems={staticConfig.detailWalletAccountBreadcrumbItems}>
      <TopContent
        pageTitle={labelConfig.detailWalletAccount}
        createPageTitle={labelConfig.detailWalletAccount}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
            marginTop: 20,
          }}
        >
          <div layout="vertical" style={{ paddingTop: 20, marginBottom: 50 }}>
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.generalInfo}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10 }} />
            <Row>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Dropdown.Button
                  menu={menuProps}
                  icon={<SettingOutlined />}
                  placement="topLeft"
                >
                  Actions
                </Dropdown.Button>
              </Col>
            </Row>

            {/* <AccountFacility
              accountName={WalletAccountDetails?.name}
              productName={WalletAccountDetails?.savingsProductName}
              accountNo={WalletAccountDetails?.nubanNumber}
              status={WalletAccountDetails?.status}
              subStatus={WalletAccountDetails?.subStatus}
            /> */}

            <AccountFacility
              status={WalletAccountDetails?.status?.text}
              name={WalletAccountDetails?.savingsAccountData?.clientName}
              nubanNumber={WalletAccountDetails?.nubanNumber}
              amount={
                WalletAccountDetails?.savingsAccountData?.summary
                  ?.availableBalance
              }
              interest={WalletAccountDetails?.maturityValue}
              currencyCode={WalletAccountDetails?.currency?.code}
              interestPerAnnum={WalletAccountDetails?.interestRate}
              maturityDate={maturityDate}
            />

            <Row
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 20,
              }}
            >
              {transformedData?.map((section, index) => (
                <Col style={{}}>
                  <Collapse
                    className="custom-collapse"
                    // expandIconPosition="start"
                    expandIcon={<ChevronDown color="red" />}
                    style={{
                      backgroundColor: "transparent",
                      padding: 0,
                    }}
                  >
                    <Panel
                      key={index + 1}
                      header={
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: 500,
                            textTransform: "capitalize",
                          }}
                        >
                          {section.section}
                        </span>
                      }
                      style={{
                        borderRadius: "8px",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          border: "1px solid #f0f0f0",
                          borderRadius: "8px",
                          overflow: "hidden",
                        }}
                      >
                        {section?.items?.map((item, itemIndex) =>
                          renderRow(item, itemIndex, index)
                        )}
                      </div>
                    </Panel>
                  </Collapse>
                </Col>
              ))}
            </Row>
          </div>
        </Card>
        <Card
          className="custom-transaction-tab"
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            width: "100%",
            // boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
            marginTop: 24,
          }}
          tabList={tabList}
          activeTabKey={activeTabKey}
          onTabChange={onTabChange}
          tabProps={{
            size: "middle",
          }}
        >
          {contentListNoTitle[activeTabKey]}
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(ViewWalletAccount);
